import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { Checkbox } from '@src/components';

interface FormCheckboxProps {
    label: string;
    keyName: string;
    control: Control<any>;
    defaultValue?: boolean;
    className?: string;
}

export const FormCheckbox: React.FC<FormCheckboxProps> = ({
    label,
    keyName,
    control,
    defaultValue = false,
    className,
}: FormCheckboxProps) => {
    return (
        <Controller
            control={control}
            name={keyName}
            defaultValue={defaultValue}
            render={({ field: { onChange, value, ...restField } }) => (
                <Checkbox
                    rootClassName={value && `text-primary`}
                    onChange={(e) => onChange(e.target.checked)}
                    checked={!!value}
                    className={className}
                    {...restField}
                >
                    {label}
                </Checkbox>
            )}
        />
    );
};
